import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import "./Home.css";

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section section-padding">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-large">
              Where Builders<br />
              Own the Table.
            </h1>
            <p className="body-large hero-description">
              We build and own brands that solve specific problems
              for specific people. Just tools that make daily life a little easier,
              priced fairly, and built to last.
            </p>
            <div className="hero-actions">
              <Link to="/portfolio" className="btn-primary">
                View Portfolio
              </Link>
              <Link to="/about" className="btn-icon">
                Learn More <ArrowRight size={12} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* How We Build Section */}
      <section className="values-section section-padding-small">
        <div className="container">
          <h2 className="heading-1 section-title">How We Build</h2>
          <div className="values-grid">
            <div className="value-item">
              <h3 className="heading-3">Real Problems</h3>
              <p className="body-regular">
                We start with problems people face daily, not market trends
                or investor theses. If it doesn't help someone's day, we
                don't build it.
              </p>
            </div>
            <div className="value-item">
              <h3 className="heading-3">Active Partnership</h3>
              <p className="body-regular">
                Beyond capital, we provide hands-on technical expertise,
                strategic guidance, operational support, and access to our
                extensive network.
              </p>
            </div>
            <div className="value-item">
              <h3 className="heading-3">Long-term Ownership</h3>
              <p className="body-regular">
                We don't build to flip. We build to run, improve, and support
                for years. Our companies are meant to stick around.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
